import PageBox from "PFComponents/box/page_box";
import StepsDots from "PFComponents/steps_dots/steps_dots";
import PropTypes from "prop-types";
import React from "react";

import css from "./onboarding_box.less";

const OnboardingBox = ({ children, big, qaId, stepDotsProps, isLoading, style }) => (
  <div className={css.box} data-qa-id={qaId} style={style}>
    {stepDotsProps && <StepsDots style={{ marginBottom: 50 }} {...stepDotsProps} />}
    <PageBox isLoading={isLoading}>
      <div className={css.content}>
        <div className={big ? css.innerBig : css.innerSmall}>{children}</div>
      </div>
    </PageBox>
  </div>
);

OnboardingBox.propTypes = {
  children: PropTypes.node.isRequired,
  big: PropTypes.bool,
  isLoading: PropTypes.bool,
  qaId: PropTypes.string,
  style: PropTypes.object,
  stepDotsProps: PropTypes.object
};

export default OnboardingBox;
